import { useContext } from "react";
import { ToastProviderContext } from "./ToastProvider";

/**
 * Hook for accessing toast context and state management functions
 * @returns ToastProviderContextProps - The toast context with state and functions
 * @throws Error when used outside of ToastProvider
 */
export const useToasts = () => {
  const context = useContext(ToastProviderContext);

  if (context == null) {
    throw new Error("useToasts must be wrapped in <ToastProvider />");
  }

  return context;
};
